import React, { useState, useRef } from "react";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

type RpPopoverTrigger = "hover" | "focus";

type RpPopoverProps = {
  children?: React.ReactNode;
  popContent?: React.ReactNode;
  popTitle?: React.ReactNode;
  trigger?: RpPopoverTrigger[];
};

export default function RpPopover({
  children,
  popContent,
  popTitle = "",
  trigger = ["hover", "focus"],
}: RpPopoverProps) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLSpanElement | null>(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const child = (
    <span
      ref={anchorRef}
      style={{ display: "inline-block" }}
      onMouseEnter={trigger.includes("hover") ? handleOpen : undefined}
      onMouseLeave={trigger.includes("hover") ? handleClose : undefined}
      onFocus={trigger.includes("focus") ? handleOpen : undefined}
      onBlur={trigger.includes("focus") ? handleClose : undefined}
      className="mt-2"
    >
      {children}
    </span>
  );

  return (
    <>
      {child}

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="top"
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      >
        <Paper elevation={3} sx={{ boxShadow: "var(--shadow-floating)" }}>
          <Box sx={{ p: 2 }}>
            {popTitle && (
              <Typography variant="subtitle1">{popTitle}</Typography>
            )}
            <Typography variant="body2">{popContent}</Typography>
          </Box>
        </Paper>
      </Popper>
    </>
  );
}
